import React, { useState } from 'react';
import './Login.css';

const DEFAULT_USERNAME = 'admin';
const DEFAULT_PASSWORD = 'password';

function Login({ onLogin }) {
  const [username] = useState(DEFAULT_USERNAME);
  const [password] = useState(DEFAULT_PASSWORD);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // ダミー認証（将来的にはAPIと連携）
    setTimeout(() => {
      if (username === DEFAULT_USERNAME && password === DEFAULT_PASSWORD) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', DEFAULT_USERNAME);
        onLogin();
      } else {
        setError('ユーザー名またはパスワードが正しくありません');
        setIsLoading(false);
      }
    }, 500);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/iwot.png" alt="IwoT Logo" className="login-logo" />
          <h1>IwoT Console</h1>
          <p className="login-subtitle">洗浄機管理システム</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 13c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" fill="currentColor"/>
                <path d="M7 4h2v5H7V4zm0 6h2v2H7v-2z" fill="currentColor"/>
              </svg>
              {error}
            </div>
          )}

          <div className="login-input-group">
            <label htmlFor="username">ユーザー名</label>
            <input
              id="username"
              type="text"
              value={username}
              readOnly
              autoComplete="username"
              autoFocus
              disabled={isLoading}
              required
            />
          </div>

          <div className="login-input-group">
            <label htmlFor="password">パスワード</label>
            <input
              id="password"
              type="password"
              value={password}
              readOnly
              autoComplete="current-password"
              disabled={isLoading}
              required
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="login-button-content">
                <span className="login-spinner"></span>
                ログイン中...
              </span>
            ) : (
              'ログイン'
            )}
          </button>


        </form>
      </div>
    </div>
  );
}

export default Login;
